import { isValidDateDDMMMYYYY } from "./inputValidators";

// Validation function for each row in the CSV
export const isValidRowSensorsCSVReader = (row: any[]): boolean => {
  // Ensure at least 9 columns are present for all fields
  if (row.length < 9) return false;

  const [serial, mac, isManu, manuDate, firmware, hardware, resistiveElements, offset, pitch] = row;

  const isSerialString = typeof serial === "string";
  const macAsString = mac?.toString();
  const isMacValid = /^[\dA-Fa-f]{16}$/.test(macAsString);  // Adjusted MAC address validation to 16 chars

  // Validate `isManufactured` and `manufacturedDate` if provided
  const isManufactured = isManu?.toUpperCase() === "TRUE" ? true : isManu?.toUpperCase() === "FALSE" ? false : null;
  const isIsManuValid = typeof isManufactured === "boolean"; // Must be strictly boolean
  const isManuDateValid = manuDate === null || isValidDateDDMMMYYYY(manuDate);

  // Validate number fields (resistive elements, offset, pitch)
  const isFirmwareValid = typeof firmware === "string" && firmware.trim() !== "";
  const isHardwareValid = typeof hardware === "string" && hardware.trim() !== "";

  const isResistiveElementsValid = !isNaN(parseFloat(resistiveElements));
  const isOffsetValid = !isNaN(parseFloat(offset));
  const isPitchValid = !isNaN(parseFloat(pitch));

  return (
    isSerialString &&
    isMacValid &&
    isIsManuValid &&
    isManuDateValid &&
    isFirmwareValid &&
    isHardwareValid &&
    isResistiveElementsValid &&
    isOffsetValid &&
    isPitchValid
  );
};
